export default "__VITE_ASSET__CgqCQNh3__"